/**
 * Execution signal service selector (ISSUE-224).
 * - Default: main API `executionSignalApiService` (`/api/v1/execution-signals`).
 * - Mock: set `REACT_APP_EXO_EXECUTION_SIGNALS_MOCK=true` for offline demo (empty queue if DB not migrated).
 * - Legacy: `REACT_APP_EXO_EXECUTION_SIGNALS_LIVE=false` also forces mock.
 */

import type { IExecutionSignalService } from '../types/executionSignal';
import { executionSignalApiService } from './executionSignalApiService';
import { mockExecutionSignalService } from './mockExecutionSignalService';

export function isExecutionSignalsLive(): boolean {
  if (process.env.REACT_APP_EXO_EXECUTION_SIGNALS_MOCK === 'true') {
    return false;
  }
  if (process.env.REACT_APP_EXO_EXECUTION_SIGNALS_LIVE === 'false') {
    return false;
  }
  return true;
}

export function getExecutionSignalService(): IExecutionSignalService {
  return isExecutionSignalsLive() ? executionSignalApiService : mockExecutionSignalService;
}
